import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";
import CategoryCard from "@/components/base/CategoryCard";

const cardColors = [
  "bg-rose-100/60",
  "bg-emerald-100/60",
  "bg-amber-50/80",
  "bg-stone-100/60",
];

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs uppercase tracking-widest text-foreground-400 font-medium mb-3">
          {t("categories.section_label")}
        </p>
        <h2 className="text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
          {t("categories.section_title")}
          <br />
          <span className="font-serif italic">{t("categories.section_title_accent")}</span>
        </h2>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {categories.map((cat, idx) => (
            <CategoryCard
              key={cat.id}
              category={cat}
              bgColorClass={cardColors[idx % cardColors.length]}
            />
          ))}
        </div>
      </div>
    </section>
  );
}